
import { Vue, Component, Prop } from "vue-property-decorator";
import vPackageCard from "@/components/vPackageCard.vue";

@Component({
  components: {
    vPackageCard
  }
})
export default class vCarousel extends Vue {
  active = 1;
  clearSlides = false;
  @Prop() content!: any;

  next() {
    this.clearSlides = false;
    this.active = this.nextPage;
    setTimeout(() => {
      this.clearSlides = true;
    }, 5000);
  }

  prev() {
    this.clearSlides = false;
    this.active = this.previousPage;
    setTimeout(() => {
      this.clearSlides = true;
    }, 5000);
  }

  setActive(index: number) {
    this.clearSlides = false;
    this.active = index;
    setTimeout(() => {
      this.clearSlides = true;
    }, 5000);
  }

  choose(id: number) {
    this.$emit("choose", id);
  }

  get previousPage() {
    if (this.active === 1) {
      return this.content.groups.length;
    }
    else {
      return this.active - 1;
    }
  }

  get nextPage() {
    if (this.active === this.content.groups.length) {
      return 1;
    }
    else {
      return this.active + 1;
    }
  }

  get indicatorsEnabled() {
    return this.content.groups.length > 1;
  }
}
